import { Button, Container, Heading, Notice, Separator, Spinner, Text } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import * as React from 'react';
import DealerLoginForm from '../login/DealerLoginForm';
import useStores from '../stores/UseStores';
import { FetchStatus } from '../util/ApiUtil';

const DealerSetRepresentationPage = observer((): React.JSX.Element | null => {
  const {
    routeStore,
    translateStore: { translate },
    dealerLoginStore,
    dealerSetRepresentationStore,
  } = useStores();
  const { customerId, goto } = routeStore.decodedParams;
  const { status, isDealer } = dealerSetRepresentationStore;
  const [hasLoginErrored, setHasLoginErrored] = React.useState<boolean>(false);

  React.useEffect(() => {
    dealerSetRepresentationStore.init(customerId, goto);
  }, []);

  const handleLogin = async () => {
    setHasLoginErrored(false);
    const response = await dealerLoginStore.customLogin();
    if (!response) {
      setHasLoginErrored(true);
      return;
    }
    dealerSetRepresentationStore.init(customerId, goto);
  };

  if (status === FetchStatus.FETCHING) {
    return (
      <Container>
        <Spinner />
      </Container>
    );
  } else if (status === FetchStatus.ERROR && isDealer) {
    return (
      <Container>
        <Notice type="error">{translate('dealer.setRepresentation.failed')}</Notice>
        <Separator spacing="xxsmall" color="invisible" />
        <Text>
          <div className="text-center">
            <Button text={translate('dealer.setRepresentation.back')} onClick={() => routeStore.assign(goto)} iconRight="#arrow-right" />
          </div>
        </Text>
      </Container>
    );
  }

  if (!isDealer) {
    return (
      <Container>
        <Text>
          <Heading className="h4 text-center">{translate('dealer.setRepresentation.login')}</Heading>
          {hasLoginErrored && <Notice type="error">{translate('form.error')}</Notice>}
          <Separator color={'invisible'} spacing={'small'} />
          <DealerLoginForm credentials={dealerLoginStore.dealerLoginCredentials} isSubmitting={dealerLoginStore.submitting} handleSubmit={handleLogin} />
        </Text>
      </Container>
    );
  }

  return null;
});

export default DealerSetRepresentationPage;
